import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CommonCustomContainerStyles {
    container?: InjectableCss;
}

export const CommonCustomContainerStyles: CommonCustomContainerStyles = {
    container: {
        css: css`
            .content {
                h3 {
                    font-size: 22px;
                    margin-bottom: 10px;
                    font-weight: ${TYPOGRAPHY.weight.base};
                }
                p {
                    font-size: ${TYPOGRAPHY.size.small};
                }
            }
            .highlighted {
                font-size: 22px !important;
                color: ${COLORS.primary.light};
                line-height: ${TYPOGRAPHY.lineHeight.small};
            }
            .historyColor {
                color: #122e4d;
            }
            .alignCenter {
                text-align: center;
            }
            .tb--spacing-s {
                padding: 20px 0;
            }
            .tb--spacing-xs {
                padding: 10px 0;
            }
            .corevalues {
                padding: 20px 0;
                span {
                    font-size: 19px;
                    color: ${COLORS.primary.light};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 14px;
                                `,
                            ],
                            "max",
                        )}
                }
            }

            // About CRM //
            .article {
                padding: 0 26px;
                p {
                    color: ${COLORS.primary.light};
                    font-size: 17px;
                    margin-bottom: 23px;
                    line-height: ${TYPOGRAPHY.lineHeight.small};
                }
                h3 {
                    margin: 0;
                }
                span {
                    font-size: ${TYPOGRAPHY.size.large};
                }
            }

            .diversityTitle {
                h3 {
                    font-size: 22px;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }
                padding-bottom: 24px;
                border-bottom: 1px solid rgba(195, 215, 235, 0.2);
                margin-bottom: 1rem !important;
            }
            .diversitySections {
                font-size: ${TYPOGRAPHY.size.small} !important;
            }
            .diversityParagraph {
                line-height: ${TYPOGRAPHY.lineHeight.small};
                border-top: 2px solid #ffffff;
                margin-top: 2rem !important;
                padding-top: 25px;
                p {
                    font-size: 19px;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }
                p:not(:last-child) {
                    margin-bottom: 10px;
                }
            }
            .textWhite {
                color: ${COLORS.white};
            }

            .crsContent {
                padding-bottom: 15px;
                h3 {
                    margin-bottom: 12px;
                    font-size: 22px;
                    font-weight: 300;
                }
                p {
                    font-size: ${TYPOGRAPHY.size.small};
                }
            }

            .communityContent {
                h3 {
                    font-size: 22px;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    margin-bottom: 10px;
                }
                p {
                    font-size: ${TYPOGRAPHY.size.smaller};
                }
                p:not(:last-child) {
                    margin-bottom: 10px;
                }
            }

            .imgAlignment {
                display: flex;
                div {
                    padding: 10px;
                    padding-bottom: 0;
                }
                div:first-child {
                    padding-left: 0;
                }
                div:last-child {
                    padding-right: 0;
                }
            }
            // end //
            //News And Event Detail Page//
            .detailList {
                padding: 0 0 10px 0;
                margin: 20px 20px 0 20px;
            }
            .detailList > div {
                max-width: 100%;
                width: 100%;
            }
            .news-content {
                margin-bottom: 0 !important;
                div h3 {
                    font-weight: 500;
                    line-height: 1.2;
                }
            }
            .NewEvent-title {
                display: block;
                background: transparent;
                color: ${COLORS.black};
                font-size: ${TYPOGRAPHY.size.smallest};
                padding: 14px 11px;
                border-bottom: 1.5px solid #3470b2;
            }
            //newz And Event End//
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            .corevalues {
                                padding: 20px 9px;
                            }

                            .minpadding {
                                padding: 14px 9px !important;
                            }
                            .mBottom {
                                margin-bottom: 1em !important;
                            }
                            .crsContent {
                                h3 {
                                    font-size: ${TYPOGRAPHY.size.large};
                                }
                                p {
                                    font-size: ${TYPOGRAPHY.size.smallest};
                                }
                            }
                            .article {
                                h3 {
                                    margin: 0;
                                    font-size: ${TYPOGRAPHY.size.base};
                                }
                                span {
                                    font-size: ${TYPOGRAPHY.size.smaller};
                                }
                            }
                            .diversityParagraph {
                                p {
                                    font-size: ${TYPOGRAPHY.size.base};
                                }
                            }
                        `,
                        css`
                            .imgAlignment {
                                div {
                                    margin-top: 10px;
                                    padding: 5px;
                                }
                            }
                            .crsContent {
                                margin-top: 20px !important;
                            }
                            .minpadding {
                                padding: 14px 4px;
                            }
                        `,
                    ],
                    "max",
                )}
            @media (max-width: 1199px) and (min-width: 992px) {
                .minpadding {
                    padding: 14px 10px;
                }
                .dropdown-content a {
                    padding: 6px 10px;
                    text-decoration: none;
                    font-size: 14px;
                    width: 103px;
                }
            }
        `,
    },
};

const styles = CommonCustomContainerStyles;

const CommonCustomContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CommonCustomContainer,
    definition: {
        displayName: "Common Custom Container",
        group: "Common",
    },
};

export default widgetModule;
